import React from "react";
import { Link } from "react-router-dom"; // Si tu utilises Next.js, remplace par "next/link"
import config from "../../config.json";
import "./Footer.css";

const Footer = () => {
  const { releaseDate } = config;

  return (
    <footer className="bg-dark text-white py-4">
      <div className="container">
        <div className="row">
          {/* Colonne 1 - Navigation */}
          <div className="col-md-4">
            <h5>Navigation</h5>
            <ul className="list-unstyled">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/rates">Rates</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Colonne 2 - Mentions Légales */}
          <div className="col-md-4">
            <h5>Legal</h5>
            <ul className="list-unstyled">
              <li><Link to="/legal-notice">Legal Notice</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Colonne 3 - Trajets Principaux */}
          <div className="col-md-4">
            <h5>Main Routes AIRPORT</h5>
            <ul className="list-unstyled">
              <li><Link to="/rates?from=charles-de-gaulle-paris&to=disneyland#Shuttle">Charles de Gaulle → Disneyland</Link></li>
              <li><Link to="/rates?from=beauvais&todisneyland#Shuttle">Beauvais → Disneyland</Link></li>
              <li><Link to="/rates?from=orly&to=disneyland#Shuttle">Orly → Disneyland</Link></li>
              <li><Link to="/rates?from=charles-de-gaulle-airport&to=paris#Shuttle">Charles de Gaulle → Paris</Link></li>
            </ul>
          </div>
        </div>

        {/* Ligne de séparation */}
        <hr className="my-3 border-light" />

        {/* Informations de contact */}
        <div className="text-center">
          <p>© {new Date().getFullYear()} RS Transports. All Rights Reserved.</p>
          <p>Release Date: {releaseDate}</p>
          <p>Contact: <a href="mailto:contact@rstransports.com" className="jaune">contact@rstransports.com</a></p>
          <p>Phone: <a href="tel:+33668160842" className="">00 33 6 68 16 08 42</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


// import React from "react";
// import config from "../config.json";

// const Footer = () => {
//   const { releaseDate } = config;

//   return (
//     <footer className="bg-dark text-white text-center py-3">
//       <p>© {new Date().getFullYear()} RS Transports. All Rights Reserved.</p>
//       <p>Release date : {releaseDate}</p>
//       <p>Contact us: contact@rstransports.com</p>
//       <p>Phone : 00 33 6 68 16 08 42</p>
//     </footer>
//   );
// };

// export default Footer;
